export const config = {
  title: "JAJ Painting | Transforming Spaces in San Antonio & The Hill Country",
  meta: {
    description:
      "Since 2007, JAJ Painting has been delivering quality craftsmanship in San Antonio and surrounding areas, offering services like interior and exterior painting, sheetrock repairs, and wood staining.",
    keywords: [
      'JAJ Painting',
      'San Antonio Painting Services',
      'Interior Painting',
      'Exterior Painting',
      'Sheetrock Repairs',
      'Wood Staining',
      'Carpentry Services',
      'Home Improvement San Antonio',
      'Professional Painters',
      'Residential Painting',
      'Commercial Painting'
    ],
    author: "JAJ Painting",
    canonicalUrl: 'https://jajpainting.net/',
  },
  sections: {
    header: {
      businessName: "JAJ Painting",
    },
    sectionB: {
      heroTitle: "JAJ Painting",
      heroSubtitle: 'Transforming Spaces, One Brushstroke at a Time',
      learnAboutText: 'Discover Our Services',
      phoneNumber: '2105476006',
      phoneLabel: '(210) 547-6006',
      heroBackgroundImage:
        "https://media.istockphoto.com/id/1312114883/photo/mature-painter-painting-a-wall.jpg?s=612x612&w=0&k=20&c=t-afZ_AqE2YBkVrpc2VxAGtFfXpySDYrCOgLznO5cTk=",
      cardData: [
        {
          title: 'Expertise Since 2007',
          description: 'Over 15 years of experience in delivering quality painting and home improvement services.',
        },
        {
          title: 'Attention to Detail',
          description: 'We prepare surfaces properly for a flawless, long-lasting finish.',
        },
        {
          title: 'Customer Satisfaction',
          description: 'Your vision is our priority—every project is tailored to your needs.',
        },
      ],
      description:
        "At JAJ Painting, we take pride in delivering top-quality painting and home improvement services. Our skilled team specializes in house painting, tape & float, sheetrock repairs, wood staining, carpentry, and more. We believe in attention to detail, exceptional customer service, and results that last.",
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        "Explore our professional painting and home improvement services designed to transform your space.",
      cards: [
        {
          title: 'House Painting',
          description:
            'Interior and exterior painting to refresh your space.',
          imageSrc: 'https://jajpainting.net/wp-content/uploads/2025/03/1.jpg',
          imageAlt: 'House Painting',
        },
        {
          title: 'Tape & Float',
          description:
            'Smooth and seamless finishes for walls and ceilings.',
          imageSrc: 'https://jajpainting.net/wp-content/uploads/2025/03/482263683_1754666651771367_4772727698151180506_n-e1741299531847.jpg',
          imageAlt: 'Tape & Float',
        },
        {
          title: 'Sheetrock Repairs',
          description:
            'Fixing cracks, holes, and water damage.',
          imageSrc: 'https://jajpainting.net/wp-content/uploads/2025/03/482994154_1346872979783234_1734943199323895944_n-e1741299750293.jpg',
          imageAlt: 'Sheetrock Repairs',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Staining',
        'Texture Application',
        'Carpentry',
        'Garage Floor Refinishing',
        'Pressure Washing',
        'Popcorn Ceiling Removal',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://jajpainting.net/wp-content/uploads/2025/03/about.jpg',
        alt: "JAJ Painting Team",
      },
      aboutText: [
        "Since 2007, JAJ Painting has been bringing quality craftsmanship and vibrant colors to homes and businesses in San Antonio, the Hill Country, and surrounding areas.",
        "We believe in attention to detail, exceptional customer service, and results that last. Whether refreshing your home’s interior or enhancing curb appeal, we’re committed to excellence.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "JAJ Painting Logo",
      businessName: "JAJ Painting",
      contact: {
        phone: '2105476006',
        phoneLabel: '(210) 547-6006',
        email: 'levinerandy9210@icloud.com',
        website: 'https://jajpainting.net/',
        address: 'San Antonio, TX',
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
        tiktok: null,
      },
    },
    sectionF: {
      address: 'San Antonio, TX',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3443.65123456789!2d-98.493628!3d29.424122!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x865c58af12345678%3A0xabcdef1234567890!2sSan%20Antonio%2C%20TX!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus',
    },
  },
};

export default config;
